<template>
  <footer>
    <div class="container">
      <p>
        Administratorem danych osobowych jest Autopay S.A. ul. Powstańców Warszawy 6, 81-718 Sopot.
        Podanie danych osobowych jest dobrowolne, ale niezbędne do realizacji płatności. Podstawa prawna, cel,
        okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne informacje
        dotyczące zasad przetwarzania danych osobowych są szczegółowo określone w <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Polityce prywatności Autopay S.A.</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
